import { z } from "zod";

import { Intent } from "@/shared/agent-prompts/workflow-types";

export const scopeRequestedIntentSchema = z
  .enum([
    Intent.CancelAppointment,
    Intent.ConfirmAppointment,
    Intent.LeaveMessage,
    Intent.Reschedule,
    Intent.Unconfirmed,
  ])
  .nullable()
  .describe(
    "The caller's explicitly requested workflow, independently from any clinical reason: explicitly reschedule or move an existing appointment to another date/time=reschedule; cancel it=cancel_appointment; ask about or confirm it=confirm_appointment; request a callback/message=leave_message. Use unconfirmed for an ambiguous request to change/manage an existing appointment, such as 'change something about my appointment' or 'will be late'; do NOT infer a date/time change from those alone. Use null for a clinical reason, generic new booking/follow-up, history, hypothetical or negated action. Never infer a workflow just from a keyword or a clinic policy example."
  );
